import Pill from "@ingka/pill";
import React, { CSSProperties, ReactNode } from "react";

import "@ingka/focus/dist/style.css";
import "@ingka/pill/dist/style.css";
import "@ingka/svg-icon/dist/style.css";

type FixaPillProps = {
  id?: string;
  className?: string;
  "data-testid"?: string;
  "aria-label"?: string;
  disabled?: boolean;
  label?: ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  selected?: boolean;
  size?: "xsmall" | "small" | "medium";
  leadingIcon?: (prefix?: string) => React.SVGProps<SVGElement>[];
  trailingIcon?: (prefix?: string) => React.SVGProps<SVGElement>[];
  style?: CSSProperties;
  tabIndex?: number;
};

function FixaPill(props: FixaPillProps) {
  return <Pill {...props} />;
}

export default FixaPill;
